type Document = {
  title: string;
  subtitle: string | null;
};

type Form = {
  hasTimeType: boolean; // عادی فوری
  hasExtention: boolean; // تمدید ویزا
  personType: "person" | "childAndAdult";
  hasVisaType: boolean; // like: ویزا ۳۰ روزه چند بار ورود
};

type Period = {
  minimum: number;
  maximum: number;
};

type Detail = {
  validityPeriod: number | null;
  normalVisaProcessDuration: Period;
  urgentVisaProcessDuration: Period | null;
};

export type Country = {
  faName: string;
  name: string;
  countryCode: string; // NOTE: IMPORTANT, should be ISO 3166, to match with back-end
  minPrice: string;
  form: Form;
  details: Detail;
  documents: Array<Document>;
};

const COUNTRIES: Array<Country> = [
  {
    faName: "دبی",
    name: "UAE",
    countryCode: "AE",
    minPrice: "120 درهم",
    form: {
      hasTimeType: true,
      hasExtention: true,
      personType: "childAndAdult",
      hasVisaType: true
    },
    details: {
      validityPeriod: 58,
      normalVisaProcessDuration: {
        minimum: 3,
        maximum: 7
      },
      urgentVisaProcessDuration: {
        minimum: 2,
        maximum: 3
      }
    },
    documents: [
      {
        title: "اسکن گذرنامه",
        subtitle: "اسکن رنگی پاسپورت با تاریخ اعتبار حداقل ۶ ماه"
      },
      {
        title: "عکس پرسنلی",
        subtitle: "عکس با پس زمینه سفید"
      },
      {
        title: "شناسنامه ",
        subtitle: "اسکن رنگی از صفحه اول و دوم"
      },
      {
        title: "کارت ملی ",
        subtitle: "اسکن رنگی دوطرف کارت ملی"
      }
    ]
  },
  {
    faName: "آذربایجان",
    name: "Azerbaijan",
    countryCode: "AZ",
    minPrice: "33 دلار",
    form: {
      hasTimeType: false,
      hasExtention: false,
      personType: "person",
      hasVisaType: false
    },
    details: {
      validityPeriod: null,
      normalVisaProcessDuration: {
        minimum: 4,
        maximum: 5
      },
      urgentVisaProcessDuration: null
    },
    documents: [
      {
        title: "اسکن گذرنامه",
        subtitle: null
      }
    ]
  },
  {
    faName: "روسیه",
    name: "Russia",
    countryCode: "RU",
    minPrice: " 150 دلار",
    form: {
      hasTimeType: false,
      hasExtention: false,
      personType: "person",
      hasVisaType: false
    },
    details: {
      validityPeriod: 45,
      normalVisaProcessDuration: {
        minimum: 7,
        maximum: 8
      },
      urgentVisaProcessDuration: null
    },
    documents: [
      {
        title: "اسکن گذرنامه",
        subtitle: null
      },
      {
        title: "اسکن عکس 6*4 جدید",
        subtitle: null
      },
      {
        title: "رزرو بلیط و وچر هتل",
        subtitle: null
      }
    ]
  },
  {
    faName: "سنگاپور",
    name: "Singapore",
    countryCode: "SG",
    minPrice: "90 دلار",
    form: {
      hasTimeType: false,
      hasExtention: false,
      personType: "person",
      hasVisaType: false
    },
    details: {
      validityPeriod: 60,
      normalVisaProcessDuration: {
        minimum: 10,
        maximum: 11
      },
      urgentVisaProcessDuration: null
    },
    documents: [
      {
        title: "فرم اطلاعات",
        subtitle: "پس از ثبت درخواست برای شما ارسال میگردد."
      },
      {
        title: "اسکن گذرنامه",
        subtitle: null
      },
      {
        title: "اسکن عکس زمینه سفید دیجیتال متفاوت با گذرنامه",
        subtitle: null
      },
      {
        title: "اعلام تاریخ دقیق سفر",
        subtitle: null
      }
    ]
  },
  {
    faName: "اندونزی",
    name: "Indonesia",
    countryCode: "ID",
    minPrice: "190 دلار",
    form: {
      hasTimeType: true,
      hasExtention: false,
      personType: "person",
      hasVisaType: false
    },
    details: {
      validityPeriod: 90,
      normalVisaProcessDuration: {
        minimum: 12,
        maximum: 14
      },
      urgentVisaProcessDuration: {
        minimum: 4,
        maximum: 5
      }
    },
    documents: [
      {
        title: "اسکن گذرنامه",
        subtitle: null
      },
      {
        title: "رزرو بلیط رفت و برگشت",
        subtitle: null
      },
      {
        title: "اسکن عکس پرسنلی زمینه سفید جدید",
        subtitle: null
      },
      {
        title: "گواهی معتبر واکسیناسیون 3 دوز",
        subtitle: null
      },
      {
        title: "پر کردن فرم درخواست",
        subtitle: "پس از ثبت درخواست برای شما ارسال میگردد"
      },
      {
        title: "وچر کانفرم شده",
        subtitle: null
      }
    ]
  },
  {
    faName: "ازبکستان",
    name: "Uzbekistan",
    countryCode: "UZ",
    minPrice: "55 دلار",
    form: {
      hasTimeType: false,
      hasExtention: false,
      personType: "person",
      hasVisaType: false
    },
    details: {
      validityPeriod: null,
      normalVisaProcessDuration: {
        minimum: 7,
        maximum: 8
      },
      urgentVisaProcessDuration: null
    },
    documents: [
      {
        title: "اسکن گذرنامه",
        subtitle: null
      },
      {
        title: "اسکن عکس",
        subtitle: null
      },
      {
        title: "فرم مشخصات فردی",
        subtitle: "پس از ثبت درخواست برای شما ارسال میگردد"
      }
    ]
  },
  {
    faName: "عربستان",
    name: "Saudi Arabia",
    countryCode: "SA",
    minPrice: "1500 درهم",
    form: {
      hasTimeType: false,
      hasExtention: false,
      personType: "person",
      hasVisaType: false
    },
    details: {
      validityPeriod: null,
      normalVisaProcessDuration: {
        minimum: 7,
        maximum: 8
      },
      urgentVisaProcessDuration: null
    },
    documents: [
      {
        title: "اسکن گذرنامه",
        subtitle: null
      },
      {
        title: "اسکن عکس",
        subtitle: null
      }
    ]
  },
  {
    faName: "هنگ کنگ",
    name: "Hong Kong",
    countryCode: "HK",
    minPrice: " 245 دلار",
    form: {
      hasTimeType: false,
      hasExtention: false,
      personType: "person",
      hasVisaType: false
    },
    details: {
      validityPeriod: 90,
      normalVisaProcessDuration: {
        minimum: 35,
        maximum: 40
      },
      urgentVisaProcessDuration: null
    },
    documents: [
      {
        title: "اسکن گذرنامه",
        subtitle: null
      },
      {
        title: "اسکن عکس",
        subtitle: null
      },
      {
        title: "فرم درخواست",
        subtitle: "پس از ثبت درخواست برای شما ارسال میگردد"
      },
      {
        title: "تمکن مالی هزار دلار آمریکا",
        subtitle: null
      },
      {
        title: "گردش مالی 3 ماهه حساب",
        subtitle: null
      },
      {
        title: "گواهی اشتغال به کار به لاتین",
        subtitle: null
      },
      {
        title: "رزرو هتل و بلیط",
        subtitle: null
      }
    ]
  },
  {
    faName: "ایران",
    name: "Iran",
    countryCode: "IR",
    minPrice: " 22 دلار",
    form: {
      hasTimeType: false,
      hasExtention: false,
      personType: "person",
      hasVisaType: false
    },
    details: {
      validityPeriod: 30,
      normalVisaProcessDuration: {
        minimum: 7,
        maximum: 8
      },
      urgentVisaProcessDuration: null
    },
    documents: [
      {
        title: "اسکن گذرنامه مهمان",
        subtitle: null
      },
      {
        title: "اسکن عکس مهمان",
        subtitle: null
      },
      {
        title: "اسکن کارت ملی میزبان",
        subtitle: null
      },
      {
        title: "فرم اطلاعات مسافر",
        subtitle: null
      }
    ]
  }
];

export { COUNTRIES };
